export default {
    save(state, payload) {
        // Burada durumu güncelleyin veya kaydedin
        // Örneğin, yeni kullanıcıyı state'e ekleyebilirsiniz
        state.users.push(payload);
      },
};
